/** -------------------- PROCESS VARIABLES -------------------- **/
/** -------------------- Vendor names should be downcase and 'contains' -------------------- **/


const FREEPAD_RULES = [
  { vendor: 'karastan', priceThreshold: 34900 },
  { vendor: 'exquisite', priceThreshold: 34900 },
  { vendor: 'loloi', priceThreshold: 34900 },
   { vendor: 'surya', priceThreshold: 34900 },
    { vendor: 'jaipur', priceThreshold: 34900 },
    { vendor: 'rizzy', priceThreshold: 34900 },
    { vendor: 'oriental weavers', priceThreshold: 34900 }
];


const ProductCore = (() => {
  const normalize = (str = "") => str.toLowerCase().trim().split(" ").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
 
  const getProduct = () => {
    try {
      const el = document.querySelector('[id*="variantchange_productData_"]');
      return el ? JSON.parse(el.textContent.trim()) : null;
    } catch {
      return null;
    }
  };
 
  const getVariants = (product) => Array.isArray(product?.variants) ? product.variants : [];
 
  const findVariantByTitle = (variants, title) => variants.find(v => normalize(v.title) === normalize(title)) || null;
 
  const findVendorRule = (vendor) => {
    if (!Array.isArray(FREEPAD_RULES)) return null;
    const vendorLower = (vendor || "").toLowerCase();
    return FREEPAD_RULES.find(r => vendorLower.includes(r.vendor.toLowerCase())) || null;
  };
 
  return { normalize, getProduct, getVariants, findVariantByTitle, findVendorRule };
})();


function setFreePadProperty(form, shouldAdd) {
  form.querySelector('[name="properties[Bonus]"]')?.remove();
  if (!shouldAdd) return;
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'properties[Bonus]';
  input.value = '+ Free Pad (Ships Separately)';
  form.appendChild(input);
}




/** -------------------- PROCESS LOGIC & LISTENER -------------------- **/


document.addEventListener('submit', function (e) {
  const form = e.target.closest('form[action*="/cart/add"]');
  if (!form) return;


  const product = ProductCore.getProduct();
  if (!product) return;


  // ---------------------------------------------------------------- //
  // NEW: CHECK IF PRODUCT IS EXTEND WARRANTY                         //
  // ---------------------------------------------------------------- //
  const productTitle = product.title || "";
  const productType = product.type || "";
  const formHTML = form.innerHTML || "";


  // Check if the main product or the form itself belongs to Extend
  const isExtend = productType === "Extend" ||
                   productTitle.includes("Extend Protection Plan") ||
                   formHTML.includes("Extend Protection Plan");


  // ---------------------------------------------------------------- //
  // GRAB CLEAN AVAILABILITY TEXT ONLY & ATTACH TO CART               //
  // ---------------------------------------------------------------- //
  const availabilityEl = document.getElementById("displayBackOrder_" + product.id);
 
  // Only attach the availability if this is NOT an Extend product!
  if (availabilityEl && !isExtend) {
    // 1. Scrape just the inner text, ignoring the HTML entirely
    const spanEl = availabilityEl.querySelector('span');
    const cleanText = spanEl ? spanEl.innerText.trim() : availabilityEl.innerText.replace('Availability:', '').trim();


    // 2. Clean up any old tags
    form.querySelector('[name="properties[Availability]"]')?.remove();
    form.querySelector('[name="properties[Status]"]')?.remove();


    // 3. Attach pure text under the "Status" property
    if (cleanText) {
      const availInput = document.createElement('input');
      availInput.type = 'hidden';
      availInput.name = 'properties[Status]';
      availInput.value = cleanText;
      form.appendChild(availInput);
    }
  }
  // ---------------------------------------------------------------- //




  const rule = ProductCore.findVendorRule(product.vendor);
  if (!rule) return;


  // 1. Grab the exact variant ID securely from the URL
  const params = new URLSearchParams(window.location.search);
  let variantId = params.get("variant");


  // Fallback to the input or first variant if URL hasn't updated yet
  if (!variantId) {
    variantId = form.querySelector('[name="id"]')?.value || (product.variants && product.variants.length > 0 ? product.variants.id : null);
  }


  // 2. Find the exact price directly from the JSON data
  const variants = ProductCore.getVariants(product);
  const variant = variants.find(v => v.id == variantId);
  const priceCents = variant ? Number(variant.price || 0) : 0;
 
  // Safely check your product type using your existing global variable
  const isRug = (typeof TYPE_RUG !== 'undefined') ? (productType === TYPE_RUG) : (productType === "Rugs");


  // Check if this specific variant meets your threshold
  const addPad = (priceCents >= rule.priceThreshold) && isRug;


  // Clean up the old tag, then attach the new one if it qualifies!
  form.querySelector('[name="properties[Bonus]"]')?.remove();
  if (addPad) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[Bonus]';
    input.value = '+ Free Pad (Ships Separately)';
    form.appendChild(input);
  }
}, true);

